import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQm3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconQm3"><Path d="M20.5 15.5H8.5M8.5 15.5L3.5 20.5M8.5 15.5V3.99976" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 7.5L8.5 3.5L12.5 7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconQm3;
